(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  function initialiseFooter() {
    document.querySelectorAll('.icconx-footer-menu').forEach((menu) => {
      if (menu.dataset.initialised) return;
      menu.dataset.initialised = 'true';
      const summary = menu.querySelector('summary');
      const update = () => {
        menu.open = desktop.matches;
        if (summary) summary.tabIndex = desktop.matches ? -1 : 0;
      };
      update();
      desktop.addEventListener('change', update);
    });
  }
  initialiseFooter();
  document.addEventListener('shopify:section:load', initialiseFooter);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header__menu details[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('.is-open')?.classList.remove('is-open');
      menu.querySelector('summary')?.focus();
    });
  });
})();

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-icconx-sort]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});

/* Collection actions: delegated to survive Shopify section updates. */
document.addEventListener('click', async (event) => {
  const view = event.target.closest('[data-icconx-view]');
  if (view) {
    const wrapper = view.closest('.icconx-collection-wrapper');
    const list = wrapper.classList.toggle('icconx-list-view');
    view.setAttribute('aria-pressed', String(list));
    view.setAttribute('aria-label', list ? 'Switch to grid view' : 'Switch to list view');
    view.querySelector('svg').innerHTML = list ? '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>' : '<rect x="2" y="3" width="7" height="7" rx=".5"/><rect x="2" y="14" width="7" height="7" rx=".5"/><path d="M13 4h9M13 9h6M13 15h9M13 20h6"/>';
  }
  const share = event.target.closest('[data-icconx-share]');
  if (share) {
    const dialog = document.getElementById('IcconxShareDialog');
    const url = dialog.querySelector('input').value;
    const title = document.querySelector('.icconx-collection-title')?.textContent.trim() || document.title;
    if (navigator.share) {
      try { await navigator.share({title, url}); return; }
      catch (error) { if (error.name === 'AbortError') return; }
    }
    dialog.querySelector('[data-icconx-share-status]').textContent = '';
    dialog.showModal();
  }
  const copy = event.target.closest('[data-icconx-copy]');
  if (copy) {
    const dialog = copy.closest('dialog'), input = dialog.querySelector('input');
    try {
      await navigator.clipboard.writeText(input.value);
      dialog.querySelector('[data-icconx-share-status]').textContent = 'Link copied';
    } catch {
      input.focus(); input.select();
      dialog.querySelector('[data-icconx-share-status]').textContent = 'Select and copy the link above.';
    }
  }
});

/* Homepage header: stable white state after leaving the top of the page. */
(()=>{if(!document.body.classList.contains('template-index'))return;let queued=false;const update=()=>{document.body.classList.toggle('ix-header-scrolled',window.scrollY>48);queued=false};window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(update)}},{passive:true});window.addEventListener('pageshow',update);update()})();
